export const getMuskUsmLandAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.muskUsmLand && sushi.contracts.muskUsmLand.options.address
}

export const getMuskUsmLandContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.muskUsmLand
}

export const getWaitingToMintLength = async muskUsmLand => {
  return muskUsmLand.methods.getWaitingToMintLength().call()
}

export const getStartBlock = async (muskUsmLand) => {
  return await muskUsmLand.methods.startBlock().call()
}

export const getEndBlock = async (muskUsmLand) => {
  return await muskUsmLand.methods.endBlock().call()
}

export const mint = async (muskUsmLand, payToken, payAmount, account) => {
  return muskUsmLand.methods
    .mint(payToken, payAmount)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

export const mintByBNB = async (muskUsmLand, payAmount, account) => {
  return muskUsmLand.methods
    .mint('0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', payAmount)
    .send({ from: account, value: payAmount })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

export const getPayTokenInfos = async (muskUsmLand, payTokens) => {
  return muskUsmLand.methods.getPayTokenInfos(payTokens).call()
}

